<template>
  <section>
    <div :class="{quillsimple: theme === 'bubble'}" ref="editor" :style="'height:' + height + 'px; opacity: ' + (disabled ? 50 : 100) + '%;'"></div>
    <b-modal v-model="imageUrlModal" hide-footer>
      <b-row slot="modal-header">
        <b-col>
          <h6>{{ $t('views.quill.addPhotoURL') }}</h6>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-8" >
          <b-row class="pl-4">
          <b-form-checkbox class="pr-4" :disabled="imageType.includes(2)" v-model="imageType" :value="1">{{$t('views.quill.addImageFromComputer')}}</b-form-checkbox>
          <b-form-checkbox :disabled="imageType.includes(1)" v-model="imageType" :value="2">{{$t('views.quill.addImageFromURL')}}</b-form-checkbox>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col v-if="imageType.includes(1)">
          <b-form-file @change="fileUploadHandler($event)" v-model="imageBase64" name="logo" accept=".jpg, .png, .gif"
                        :label="$t('views.quill.image')">
          </b-form-file>
        </b-col>
        <b-col v-if="imageType.includes(2)">
          <input v-model="imageUrl" :label="$t('views.quill.imageURL')"/>
        </b-col>
      </b-row>
      <b-row>
        <b-button class="btn float-left btn-primary" @click="imageHandler()">{{$t('buttons.add')}}</b-button>
        <b-button class="btn float-left btn-secondary" @click="cancelButton()">{{$t('buttons.cancel')}}</b-button>
      </b-row>
    </b-modal>
  </section>
</template>

<script>
import Quill from 'quill'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.bubble.css'
import 'quill/dist/quill.snow.css'
import htmlEditButton from 'quill-html-edit-button'
// import htmlEditButton from 'quill-html-edit-button-vuetify'

export default {
  name: 'quillEditor',
  props: {
    value: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: function () {
        return 'snow'
      }
    },
    height: {
      type: Number,
      default: function () {
        return 300
      }
    },
    disabled: {
      type: Boolean,
      default: function () {
        return false
      }
    }
  },
  data () {
    return {
      editor: null,
      innerValue: this.value,
      imageUrlModal: false,
      imageUrl: '',
      imageBase64: null,
      imageType: [],
      editorRange: null
    }
  },
  mounted () {
    let fontSizes = ['8px', '9px', '10px', '12px', '14px', '16px', '20px', '24px', '32px', '42px', '54px', '68px', '84px', '98px']
    let fontFamilies = ['Arial', 'Verdana', 'Trebuchet MS', 'Times New Roman', 'Georgia', 'Courier New']
    let options = {
      modules: {
        toolbar: {
          container: [
            ['bold', 'italic', 'underline', 'strike'], // toggled buttons
            ['blockquote', 'code-block'],
            ['link', 'image'],
            [{ 'size': fontSizes }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'color': [] }, { 'background': [] }], // dropdown with defaults from theme
            [{ 'font': fontFamilies }],
            [{ 'align': [] }],
            ['clean']
          ],
          handlers: {
            'image': this.openModal
          }
        },
        htmlEditButton: {},
        clipboard: {
          matchVisual: false
        }
      },
      theme: this.theme
    }
    let size = Quill.import('attributors/style/size')
    let Block = Quill.import('blots/block')
    Block.tagName = 'DIV'
    Quill.register(Block, true)
    size.whitelist = fontSizes
    Quill.register(size, true)
    Quill.register({ 'modules/htmlEditButton': htmlEditButton })
    let font = Quill.import('attributors/style/font')
    font.whitelist = fontFamilies
    Quill.register(font, true)
    this.$refs.editor.innerHTML = this.value
    this.editor = new Quill(this.$refs.editor, options)
    this.editor.on('text-change', function () {
      return this.update()
    }.bind(this))
    if (this.disabled) {
      this.editor.disable()
    } else {
      this.editor.enable()
    }
  },
  watch: {
    value (value) {
      if (value !== this.innerValue) {
        this.editor.root.innerHTML = value
        this.innerValue = value
      }
    },
    disabled (value) {
      if (value) {
        this.editor.disable()
      } else {
        this.editor.enable()
      }
    }
  },
  methods: {
    update () {
      this.innerValue = this.editor.getText() ? this.editor.root.innerHTML : ''
      this.$emit('input', this.innerValue)
    },
    openModal () {
      this.editorRange = this.editor.getSelection()
      this.imageUrlModal = true
    },
    imageHandler () {
      if (this.imageType.includes(2)) {
        if (this.imageUrl !== '') {
          this.editor.insertEmbed(this.editorRange.index, 'image', this.imageUrl, Quill.sources.USER)
          let img = this.editor.root.querySelector('img[src="' + this.imageUrl + '"]')
          if (img) {
            img.style.maxWidth = '540px'
            img.style.maxHeight = '900px'
          }
          this.innerValue = this.editor.root.innerHTML
          this.$emit('input', this.innerValue)
          this.imageUrl = ''
          this.editorRange = null
          this.imageUrlModal = false
        }
      } else if (this.imageType.includes(1)) {
        let reader = new FileReader()
        reader.onload = (e) => {
          this.editor.insertEmbed(this.editorRange.index, 'image', e.target.result, Quill.sources.USER)
          let img = this.editor.root.querySelector('img[src="' + e.target.result + '"]')
          if (img) {
            img.style.maxWidth = '540px'
            img.style.maxHeight = '900px'
          }
          this.innerValue = this.editor.root.innerHTML
          this.$emit('input', this.innerValue)
          this.update()
        }
        if (this.imageBase64) {
          reader.readAsDataURL(this.imageBase64)
        }
        this.imageBase64 = null
        this.imageUrlModal = false
      }
      this.imageType = []
    },
    fileUploadHandler (file) {
      if (file) {
        this.imageBase64 = file
      }
    },
    cancelButton () {
      this.imageUrlModal = false
    }
  }
}
</script>
